









import { ref, defineComponent, watch } from '@vue/composition-api';

const name = 'ttam-creative-website-url-product-sales-input';
export default defineComponent({
  name,
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const __externalUrl = ref(props.value);

    watch(
      () => props.value,
      () => {
        __externalUrl.value = props.value;
      },
    );

    watch(__externalUrl, (val: string) => {
      if (val !== props.value) {
        emit('change', val);
        emit('input', val);
      }
    });

    return {
      name,
      __externalUrl,
    };
  },
});
